import React from 'react';
import { ReactQueryConfigProvider } from 'react-query';
import { HashRouter as Router } from 'react-router-dom';
import { ViewportProvider } from 'hooks/useViewport';
import PageContent from 'components/PageContent';
import WaitingScreen from 'components/WaitingScreen';
import TimeoutScreen from 'components/TimeoutScreen';
import { StateProvider } from 'hooks/useGlobalState';
import { mainReducer, mainInitialState } from 'reducers/main';
import './index.css';

import { POPOVER_CONTAINER_ID } from 'utils/appLayout';

const reactQueryConfig = {
  queries: {
    retry: 1,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  },
};

// SPA entry point for "free" (hosted free) HTML template
export default function HostedFreeApp() {
  return (
    <ReactQueryConfigProvider config={reactQueryConfig}>
      <Router hashType="noslash">
        <ViewportProvider>
          <StateProvider initialState={mainInitialState} reducer={mainReducer}>
            <WaitingScreen showProgressBar={true} />
            <TimeoutScreen />
            <PageContent />
          </StateProvider>
          <div id={POPOVER_CONTAINER_ID} className="popoverContainer" />
        </ViewportProvider>
      </Router>
    </ReactQueryConfigProvider>
  );
}
